// Textes communs utilisés dans toute l'application
export const COMMON_TEXTS = {
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  warning: 'Avertissement',
  info: 'Information',
  notification: 'Notification',
  add: 'Ajouter',
  edit: 'Modifier',
  delete: 'Supprimer',
  save: 'Enregistrer',
  cancel: 'Annuler',
  actions: 'Actions',
  move: 'Déplacer',
  next: 'Suivant',
  previous: 'Précédent',
  saving: 'Enregistrement...',
  confirm: 'Confirmer',
  search: 'Rechercher...',
  unknownOrganization: 'Organisation inconnue',
  errorLoadingData: 'Erreur lors du chargement des données',
  default: 'défaut',
  confirmationDialog: {
    defaultConfirm: 'Confirmer',
    defaultCancel: 'Annuler'
  },
  // Document dialog texts (generic for all entities)
  documentDialog: {
    title: 'Document JSON',
    description: 'Visualisation du document complet en format JSON',
    viewDocument: 'Voir le document',
    viewDocumentTooltip: 'Voir le document JSON complet'
  }
} as const;